import { render } from "./body_main_banner2.vue?vue&type=template&id=fd43fe16&scoped=true"
import script from "./body_main_banner2.vue?vue&type=script&lang=js"
export * from "./body_main_banner2.vue?vue&type=script&lang=js"

import "./body_main_banner2.vue?vue&type=style&index=0&id=fd43fe16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd43fe16"]])

export default __exports__